import { render, staticRenderFns } from "./ThgVehicleTable.vue?vue&type=template&id=3e8ca574"
import script from "./ThgVehicleTable.vue?vue&type=script&lang=ts"
export * from "./ThgVehicleTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports